import links from 'links'
import { useDevice } from 'device'
import React, { useMemo } from 'react'
import { useModuleTitle } from 'models/settings'

import { Grid } from 'components/layout'
import { Text } from 'components/dataDisplay'

import { ServiceCard, SingleServiceCard } from './components'

import rent from './images/rent@2x.png'
import unsteady from './images/unsteady@2x.png'


const BusinessBlock = (props) => {
  const { className, withUnsteady, withRent } = props

  const { title: unsteadyModuleTitle } = useModuleTitle('SELL_POINT_MOVE')
  const { title: rentModuleTitle } = useModuleTitle('SPACES_FOR_RENT')
  const { isTablet, isMobile } = useDevice()

  const items = useMemo(() => {
    return [
      withRent && {
        title: rentModuleTitle,
        text: `
          Посмотрите на карте, где расположены помещения для аренды в вашем
          городе и выберите лучшую локацию для своего бизнеса
        `,
        image: rent,
        to: links.rent.root,
      },
      withUnsteady && {
        title: unsteadyModuleTitle,
        text: 'Посмотрите на карте, где расположены НТО в вашем городе и выберите лучшую локацию для своего бизнеса',
        image: unsteady,
        to: links.nto,
      },
    ].filter(Boolean)
  }, [ withRent, unsteadyModuleTitle, withUnsteady, rentModuleTitle ])

  const isSingleItem = isTablet && items.length === 1

  return (
    <div className={className}>
      <Text
        message="Бизнесу"
        size={isMobile ? 'h20-28' : 'h32'}
      />
      <Grid
        className={isMobile ? 'pt-20px' : isTablet ? 'pt-24px' : 'pt-32px'}
        columns={isMobile ? 2 : isSingleItem ? 1 : 3}
        gutter={isMobile ? 16 : isTablet ? 24 : 32}
      >
        {
          items.map(({ title, text, image, to }, index) => (
            isSingleItem ? (
              <SingleServiceCard
                key={index}
                title={title}
                text={text}
                image={image}
                to={to}
              />
            ) : (
              <ServiceCard
                key={index}
                title={title}
                image={image}
                to={to}
              />
            )
          ))
        }
      </Grid>
    </div>
  )
}

export default BusinessBlock